package navigation.settings.countries.allcountries

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.country.domain.repository.CountryRepository
import com.essntl.features.country.ui.allcountries.AllCountriesEvent
import com.essntl.features.country.ui.allcountries.AllCountriesState
import com.essntl.features.country.ui.allcountries.AllCountriesViewModel

class AllCountriesScreenModel(
    countryRepository: CountryRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AllCountriesState>(AllCountriesState()) {

    private val viewModel =
        AllCountriesViewModel(
            countryRepository = countryRepository,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllCountriesEvent) = viewModel.onEvent(event)
}